import _ from 'lodash';

import { consumer, core, safeEnumCompare } from '@tock/coretypes';
import { ticketTypeStatusForPurchaseSize } from 'utils/calendar';
import protos from 'utils/protos';

const { TicketType } = protos;

export const getSizesAndStatuses = (
  ticketType: core.TicketType,
  ticketGroup: consumer.CalendarTicketGroup[]
) => {
  const sizes = ticketType.purchaseSize;

  return _.orderBy(
    _.map(sizes, (size: number) => {
      return {
        size,
        status: ticketTypeStatusForPurchaseSize(ticketGroup, ticketType.id, size),
      };
    }),
    ['size'],
    ['asc']
  );
};

export function isCutoffIntervalAfter(ticketType: core.ITicketType | undefined): boolean {
  return (
    ticketType !== undefined &&
    safeEnumCompare(
      ticketType.cutoffType,
      TicketType.CutoffType,
      TicketType.CutoffType.INTERVAL_AFTER
    )
  );
}
